import { CSS, StyleProps } from "@shared/primitive-components"

export const clickable = () => ({
  cursor: `pointer`,
})

export const marginTop = (props: StyleProps) => ({
  marginTop: props.theme.spacing(5),
})

export const instruction = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(4),
})

export const errorWithMargin = (props: StyleProps) => ({
  color: props.theme.palette.error,
  marginBottom: props.theme.spacing(4),
})

export const error = (props: StyleProps) => ({
  color: props.theme.palette.error,
})

export const errorDetail = (props: StyleProps) => ({
  color: props.theme.palette.coal.dark,
})

export const errorStack = (props: StyleProps): CSS => ({
  color: props.theme.palette.error,
  textAlign: `left`,
  marginTop: props.theme.spacing(6),
})

export const errorStackDetail = (): CSS => ({
  color: `black`,
  textAlign: `left`,
  maxWidth: `800px`,
  wordWrap: `break-word`,
})

export const userComponentWrap = (props: StyleProps): CSS => ({
  backgroundColor: props.theme.palette.white,
  textAlign: `center`,
})

export const text = (): CSS => ({
  lineHeight: `2em`,
})
